import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useIsDesktop } from "@/lib/useIsDesktop";
import GettingStarted from "@/components/GettingStarted";
import { HomeTiles } from "@/components/home/HomeTiles";
import { QuickRow } from "@/components/home/QuickRow";
import { DashboardStats } from "@/components/home/DashboardStats";
import { InstallAppCard } from "@/components/InstallPrompt";
import { isSimple } from "@/lib/edition";

export default function Dashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const desktop = useIsDesktop();
  const guide = user?.role === "admin" && user?.company && !user.company.is_default && !user?.onboarding?.checklist_hidden;

  if (!desktop || isSimple(user)) {
    return (
      <div className="space-y-6">
        <HomeTiles />
        <InstallAppCard />
        {guide && <GettingStarted />}
      </div>
    );
  }
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <p className="text-sm text-muted-foreground">Ecco l'andamento della tua attività.</p>
        <Button onClick={() => navigate("/preventivi?new=1")} data-testid="new-quote-trigger-button">
          <Plus className="w-4 h-4 mr-1.5" /> Nuovo Preventivo
        </Button>
      </div>
      <QuickRow />
      {guide && <GettingStarted />}
      <DashboardStats />
    </div>
  );
}
